<template>
  <div class="progress" :class="cssClass" :style="getComputedProgressStyle()">
    <div
      class="progress-bar"
      role="progressbar"
      :aria-valuenow="progressValue"
      aria-valuemin="0"
      aria-valuemax="100"
      :style="getComputedBarStyle()"
    />
  </div>
</template>
<script>
export default {
  props: {
    progressValue: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 8
    },
    borderRadius: {
      type: Number,
      default: 0
    },
    cssClass: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "#9e9e9e"
    },
    color: {
      type: String,
      default: "#757575"
    }
  },
  methods: {
    getComputedProgressStyle() {
      return `height: ${this.height}px; background-color: ${this.backgroundColor}; border-radius: ${this.borderRadius}px`;
    },
    getComputedBarStyle() {
      return `width: ${this.progressValue}%; background-color: ${this.color};`;
    }
  }
};
</script>
